import { IUserTypeEnum } from '@/entities/admin-app/user';
import { UserStatusEnum } from '@/types/enums/user';
import { TFunction } from 'i18next';

export const userTypeOptions = [
  { value: IUserTypeEnum.Contact.toString(), label: 'Локальный' },
  { value: IUserTypeEnum.LDAP.toString(), label: 'LDAP' },
  { value: IUserTypeEnum.SSO.toString(), label: 'SSO' }
];

export const userStatusesOptions = (t: TFunction) => [
  {
    label: t('users.actionList.active'),
    value: UserStatusEnum.Active.toString()
  },
  {
    label: t('users.actionList.locked'),
    value: UserStatusEnum.Ban.toString()
  }
];
